module.exports = __webpack_public_path__ + "static/media/logo.79d94c82.png";